import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const TopBar = () => {
  const [company, setCompany] = useState(null);

  useEffect(() => {
    const fetchCompany = async () => {
      try {
        const res = await fetch(
          "https://asc-admin.vercel.app/api/company/68ebabc1c3db3fcb7ac32696"
        );
        const data = await res.json();
        if (data.success) {
          setCompany(data.data);
        }
      } catch (err) {
        console.error("Failed to fetch company data:", err);
      }
    };

    fetchCompany();
  }, []);

  if (!company) {
    return null; // Or a loading spinner if you prefer
  }

  const { contact, officeTime } = company;
  const address = `${contact.address.city}, ${contact.address.country}`;
  const phone = contact.phone;
  const officeHours = `Mon-Sat: ${officeTime.start} - ${officeTime.end}`;

  return (
    <div id="top-bar">
      <div id="top-bar-inner" className="container">
        <div className="top-bar-inner-wrap">
          <div className="top-bar-content">
            <div className="inner">
              <span className="address content">{address}</span>
              <span className="phone content">{phone}</span>
              <span className="time content">{officeHours}</span>
            </div>
          </div>
          <div className="top-bar-socials">
            <div className="inner">
              <span className="text">Follow us:</span>
              <span className="icons">
                <Link to="#">
                  <i className="fa fa-facebook" />
                </Link>
                <Link to="#">
                  <i className="fa fa-instagram" />
                </Link>
                <Link to="#">
                  <i className="fa fa-pinterest-p" />
                </Link>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TopBar;
